export const MonitoringProgress = `EmploymentEquity/MonitoringProgress`;
export const SearchMonitoringProgress = MonitoringProgress + '/Search';